// import React, { useState, useEffect, useRef } from "react";
// import { Header } from "../../components/Header/Header";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Cookies from "js-cookie";
// import { getFreshAccessToken } from "../chat/api";
// import api from "../chat/api";
// import PlanComparisonPopup from "../chat/PlanComparisonPopup";
// import CancelSubscriptionPopup from "../chat/CancelSubscriptionPopup";
// import PlanComparisonPopups from "../chat/PlanComparisonPopups";


// const Billing = () => {
//   const [token, setToken] = useState(null);
//   const [subscriptionType, setSubscriptionType] = useState("");
//   const [isLoadingSubscription, setIsLoadingSubscription] = useState(true);
//   const [uploadedDocsCount, setUploadedDocsCount] = useState(0);
//   const [expiresOn, setExpiresOn] = useState("");
//   const [isPopupOpen, setIsPopupOpen] = useState(false);
//   const [selectedPlan, setSelectedPlan] = useState("Grow");
//   const [isTrialActive, setIsTrialActive] = useState(true);
//   const [popupType, setPopupType] = useState("payment");
//   const [isPaidYearlyPlan, setIsPaidYearlyPlan] = useState(false);
//   const [isYearlyTrial, setIsYearlyTrial] = useState(false);
//   const [planType, setPlanType] = useState("");
//   const [quotaType, setQuotaType] = useState("");
//   const [currencySymbol, setCurrencySymbol] = useState("$");
//   const [countryCode, setCountryCode] = useState("");
//   const [userIP, setUserIP] = useState("");
//   const [cardLast4, setCardLast4] = useState("");
//   const [cardExpiry, setCardExpiry] = useState("");
//   const [cardBrand, setCardBrand] = useState("");
//   const [isProcessingPayment, setIsProcessingPayment] = useState(false);
//   const [isCancellingSubscription, setIsCancellingSubscription] = useState(false);
//   const [showCancelPopup, setShowCancelPopup] = useState(false);
//   const [isActivating, setIsActivating] = useState(false);
//   const [showGetStarted, setShowGetStarted] = useState(false);
//   const pollingActiveRef = useRef(true);
//   const previousSubscriptionType = useRef("");
//   const previousPlanType = useRef("");


//   useEffect(() => {
//     fetchPlans();
//     fetchSubscriptionStatus();
//   }, []);


//   const fetchPlans = async () => {
//     let token = await getFreshAccessToken();
//     try {
//       const response = await api.get("api/v1/accounts/get-plans/");
//       if (response.status === 200) {
//         const { ip_address, currency, country_code } = response.data;
//         setUserIP(ip_address);
//         setCountryCode(country_code);
//         if (currency === "INR") {
//           setCurrencySymbol("₹");
//         } else {
//           setCurrencySymbol("$");
//         }
//       }
//     } catch (error) {
//       console.error("Error fetching plans:", error);
//     }
//   };


//   const fetchSubscriptionStatus = async () => {
//     let token = await getFreshAccessToken();
//     try {
//       const response = await api.get(
//         "api/v1/accounts/get-subscription-status/",
//         {
//           validateStatus: (status) => true,
//         }
//       );


//       const data = response.data;
//       const isCancelled =
//         (response.status === 200 || response.status === 404) &&
//         data.subscription_type === "None" &&
//         data.plan_type === "None" &&
//         data.has_cancelled_once === true;


//       if (isCancelled) {
//         toast.info("Subscription cancelled. Redirecting to plan selection...");
//         window.location.href = "/payment";
//         return;
//       }


//       if (response.status === 200) {
//         const {
//           subscription_type,
//           plan_type,
//           uploaded_docs_count,
//           expires_on,
//           card_last4,
//           card_expiry,
//           card_brand,
//           quota,
//         } = response.data;
//         setSubscriptionType(subscription_type);
//         setPlanType(plan_type);
//         setUploadedDocsCount(uploaded_docs_count || 0);
//         setExpiresOn(expires_on);
//         setCardLast4(card_last4);
//         setCardExpiry(card_expiry);
//         setCardBrand(card_brand);
//         setQuotaType(quota);
//         previousSubscriptionType.current = subscription_type;
//         previousPlanType.current = plan_type;
        
//         // FIXED: Removed && plan_type === "monthly" so paid yearly plans aren't mistakenly treated as trials.
//         const isTrial = !(
//           subscription_type === "paid_subs" ||
//           subscription_type === "pending_cancellation" ||
//           subscription_type === "plan_upgrade_pending_payment"
//         );
//         setIsTrialActive(isTrial);
//         setIsPaidYearlyPlan(
//           (subscription_type === "paid_subs" ||
//             subscription_type === "pending_cancellation") &&
//             plan_type === "yearly"
//         );
//         const isActualTrial = subscription_type === "trial" && plan_type === "trial";
//         setIsYearlyTrial(isActualTrial && quota === "yearly");
//       }
//     } catch (error) {
//       console.error("Failed to fetch subscription status:", error);
//     } finally {
//       setIsLoadingSubscription(false);
//     }
//   };


//   const handleOpenPopup = (planTitle, type = "payment", selectedPlanType = "monthly") => {
//     setSelectedPlan(planTitle);
//     setPopupType(type);
//     setIsProcessingPayment(false);
//     setPlanType(selectedPlanType);


//     const isTrial = subscriptionType === "trial" && planType === "trial";
//     const isTrialUser = isTrial || isTrialActive;


//     if (isTrialUser) {
//       setIsPopupOpen(true);
//       return;
//     }


//     setIsPopupOpen(true);
//   };


//   const handleClosePopup = () => {
//     pollingActiveRef.current = false;
//     setIsPopupOpen(false);
//     setIsProcessingPayment(false);
//   };


//   const handleUpgrade = async () => {
//     pollingActiveRef.current = true;
//     setIsProcessingPayment(true);
//     // Add your upgrade logic here
//   };


//   const handleUpdatePaymentMethod = async () => {
//     try {
//       const response = await api.post(`api/v1/accounts/create-portal-session/`);
//       if (response.status === 200 && response.data?.url) {
//         window.location.href = response.data.url;
//       } else {
//         toast.error("Failed to retrieve payment portal link.");
//       }
//     } catch (error) {
//       console.error("Error creating portal session:", error);
//       toast.error("Something went wrong while opening the payment portal.");
//     }
//   };


//   const handleCancelSubscription = async () => {
//     setIsCancellingSubscription(true);
//     // Add your cancel subscription logic here
//   };


//   const trialDocsLimit = 5;
//   const paidDocsLimit = 70;
//   const totalDocs = isTrialActive ? trialDocsLimit : paidDocsLimit;
//   // FIXED: Constrain the percentage max to 100% so progress bar fill doesn't overflow if count > totalDocs (e.g. 10/5)
//   const docsUsedPercentage = Math.max(0, Math.min((uploadedDocsCount / totalDocs) * 100, 100));


//   const totalTrialDays = 14;
//   const getDaysLeft = () => {
//     if (!expiresOn) return 0;
//     const today = new Date();
//     const expiry = new Date(expiresOn);
//     today.setHours(0, 0, 0, 0);
//     expiry.setHours(0, 0, 0, 0);
//     const diffTime = expiry.getTime() - today.getTime();
//     const dayDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
//     return Math.max(dayDiff, 0);
//   };


//   const trialDaysLeft = getDaysLeft();
//   // FIXED: Constrain trial percentage to prevent CSS overflow 
//   const trialUsedPercentage = Math.max(0, Math.min(((totalTrialDays - trialDaysLeft) / totalTrialDays) * 100, 100));


//   const formatDate = (isoDate) => {
//     if (!isoDate) return "";
//     const date = new Date(isoDate);
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const day = String(date.getDate()).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${month}/${day}/${year}`;
//   };


//   const formattedExpiryDate = formatDate(expiresOn);


//   if (isLoadingSubscription) {
//     return (
//       <div className="flex items-center justify-center min-h-screen w-2/3">
//         <div className="spinner"></div>
//       </div>
//     );
//   }
  


//   return (
//     <div className="w-full">
//       <div className="billing-wrapper">
//         <div>
//           <div className="mt-1">
//             <h2 className="billing-plan-box-title">Billing Information</h2>
//           </div>
//           <div className="billing-upgrade-banner mt-1">
//             <div className="billing-upgrade-left">
//               {isPaidYearlyPlan ? (
//                 <div className="flex items-center gap-2">
//                   <span className="text-white text-base font-semibold">
//                     Need More Power?⚡️
//                   </span>
//                 </div>
//               ) : (
//                 <h3 className="billing-upgrade-title">
//                   Ready for Even More? 🚀
//                 </h3>
//               )}


//               <p className="billing-upgrade-subtitle">
//                 {isPaidYearlyPlan ? (
//                   <>
//                     Unlock Unlimited Uploads, Custom Knowledgebases &
//                     <br />
//                     Enterprise-Grade Security — with the{" "}
//                     <strong>Enterprise Plan</strong>.
//                   </>
//                 ) : (
//                   <>
//                     Upgrade to the Grow Plan for Unlimited Access and
//                     <br />
//                     Advanced Features!
//                   </>
//                 )}
//               </p>
//             </div>
//             {isPaidYearlyPlan ? (
//               <button
//                 className="billing-upgrade-btn bg-[#f1e9ff] text-[#8B55DD] cursor-pointer"
//                 onClick={() => window.open("https://app.lemcal.com/@shobhitg", "_blank")}
//               >
//                 <span className="flex items-center gap-2">
//                   Talk to Sales
//                   <img src="/coming-soon-icon.svg" alt="Talk to Sales" className="w-5 h-5" />
//                 </span>
//               </button>
//             ) : (
//               <button
//                 className="billing-upgrade-btn"
//                 onClick={() => handleOpenPopup("Grow", isTrialActive ? "payment" : "info")}
//               >
//                 {isTrialActive ? "Upgrade Now" : "Upgrade"}{" "}
//                 <span className="billing-upgrade-arrow">
//                   <img src="/account-image-upload.svg" alt="arrow" />
//                 </span>
//               </button>
//             )}


//             {isTrialActive ? (
//               <div className="billing-upgrade-image">
//                 <img src="/Illustration-1.svg" alt="Upgrade illustration" />
//               </div>
//             ) : (
//               <div className="billing-upgrade-images">
//                 <img src="/Illustration-2.svg" alt="Post-trial illustration" />
//               </div>
//             )}
//           </div>
//         </div>


//         <div className="mt-3">
//           <h2 className="billing-plan-box-title">Selected Plan</h2>
//         </div>
//         <div className="billing-plan-box relative">
//           <div className="billing-plan-header">
//             <h4 className="billing-plan-title">
//               {isYearlyTrial
//                 ? "Trial Plan"
//                 : isPaidYearlyPlan
//                 ? "Grow Plan"
//                 : isTrialActive
//                 ? "Trial Plan"
//                 : "Starter Plan"}
//             </h4>


//             <div className="billing-trial-days-left">
//               <img src="/billing-hourglass.svg" alt="hourglass icon" className="billing-trial-icon" />
//               {trialDaysLeft} days left
//             </div>
//           </div>


//           <div className="billing-plan-details">
//             <div className="billing-price">
//               {isYearlyTrial
//                 ? currencySymbol === "₹" ? "Free For 14 days" : "Free For 14 days"
//                 : isPaidYearlyPlan
//                 ? currencySymbol === "₹" ? "₹17,032.00" : "$299.00"
//                 : isTrialActive
//                 ? currencySymbol === "₹" ? "₹Free For 14 days" : "Free For 14 days"
//                 : currencySymbol === "₹" ? "₹3,338.00" : "$39.00"}
//               <span className="billing-per-month">
//                 {isYearlyTrial ? "" : isPaidYearlyPlan ? "/year" : isTrialActive ? "" : "/month"}
//               </span>
//             </div>


//             <div className="billing-feature-columns mt-2">
//               <ul className="billing-feature-list space-y-2">
//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>
//                     Upload Limit:{" "}
//                     <strong>
//                       <span className="billing-trial-note-highlights">
//                         {isPaidYearlyPlan ? "Unlimited Document Uploads" : isTrialActive ? "5 documents" : "70 documents"}
//                       </span>
//                     </strong>
//                   </span>
//                 </li>


//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>With AI Copilot and AI search on knowledgebase</span>
//                 </li>


//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>
//                     {isPaidYearlyPlan ? (
//                       <>Billed Yearly</>
//                     ) : isTrialActive ? (
//                       <>
//                         Trial Duration:{" "}
//                         <strong>
//                           <span className="billing-trial-note-highlights">14 days</span>
//                         </strong>
//                       </>
//                     ) : (
//                       <>
//                         Billed Monthly{" "}
//                         <span className="billing-trial-note">
//                           (Next billing on <strong>{formattedExpiryDate}</strong>)
//                         </span>
//                       </>
//                     )}
//                   </span>
//                 </li>
//               </ul>


//               <ul className="billing-feature-list space-y-3">
//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>
//                     AI Queries:{" "}
//                     <strong>
//                       <span className="billing-trial-note-highlights">Unlimited</span>
//                     </strong>
//                   </span>
//                 </li>


//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>
//                     Maximum File Size:{" "}
//                     <strong>
//                       <span className="billing-trial-note-highlights">
//                         {isPaidYearlyPlan || isYearlyTrial ? "25MB per document" : "25MB per document"}
//                       </span>
//                     </strong>
//                   </span>
//                 </li>


//                 <li className="flex items-start gap-2">
//                   <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
//                   <span>
//                     {isPaidYearlyPlan || !isTrialActive ? "Advanced Data Extraction" : "With Advanced Data Extraction"}
//                   </span>
//                 </li>
//               </ul>
//             </div>


//             <div className="billing-bottom-cta">
//               {!isPaidYearlyPlan && (
//                 <div href="#" className="billing-upgrade-link">
//                   Need more?{" "}
//                   <strong
//                     onClick={() => {
//                       setTimeout(() => {
//                         if (planType === "monthly" && (subscriptionType === "paid_subs" || subscriptionType === "plan_upgrade_pending_payment")) {
//                           setIsPopupOpen(true);
//                           setPopupType("info");
//                         } else {
//                           handleOpenPopup("Grow", isTrialActive ? "payment" : "info");
//                         }
//                       }, 100);
//                     }}
//                     style={{ cursor: "pointer" }}
//                   >
//                     Upgrade your plan
//                   </strong>
//                 </div>
//               )}


//               {subscriptionType === "pending_cancellation" && planType === "yearly" ? (
//                 <p className="text-gray-600 text-[14px] font-medium" style={{ marginLeft: "515px" }}>
//                   You'll still have access to premium features until <strong>{formattedExpiryDate}</strong>.
//                 </p>
//               ) : subscriptionType === "pending_cancellation" && planType === "monthly" ? (
//                 <p className="text-gray-600 text-[14px] font-medium" style={{ marginRight: "75px" }}>
//                   You'll still have access to premium features until <strong>{formattedExpiryDate}</strong>.
//                 </p>
//               ) : (
//                 <div>
//                   {subscriptionType === "paid_subs" && (planType === "monthly" || planType === "yearly") && (isPaidYearlyPlan ? (
//                     <button className="billing-cancel-btn absolute top-[9.8rem] right-4" onClick={() => setShowCancelPopup(true)}>
//                       Cancel Subscription
//                     </button>
//                   ) : (
//                     <button className="billing-cancel-btn mt-4" onClick={() => setShowCancelPopup(true)}>
//                       Cancel Subscription
//                     </button>
//                   ))}
//                 </div>
//               )}
//             </div>


//             {isPaidYearlyPlan && !(subscriptionType === "pending_cancellation" && planType === "yearly") && (
//               <p className="billing-next-billing-text ml-8" style={{ marginTop: "-1px" }}>
//                 Next billing on <strong>{formattedExpiryDate}</strong>
//               </p>
//             )}
//           </div>
//         </div>


//         {(subscriptionType === "paid_subs" || subscriptionType === "plan_upgrade_pending_payment" || subscriptionType === "pending_cancellation") &&
//           (planType === "monthly" || planType === "yearly") && (
//           <div className="flex items-center justify-between mt-3">
//             <div>
//               <h2 className="billing-usage-box-headings font-semibold text-base text-black">
//                 Payment & Invoices
//               </h2>
//               <p className="text-[14px] text-gray-500 mt-1">
//                 Manage your card and view your invoice history
//               </p>


//               <div className="flex items-center mt-3 gap-4">
//                 <div className="flex items-center gap-2">
//                   <img src="/card-icon.svg" alt="Card Icon" className="w-5 h-5 text-[#845EC2]" />
//                   {cardBrand && cardLast4 && (
//                     <span className="text-[14px] text-black font-medium">
//                       {cardBrand} ******{cardLast4}
//                     </span>
//                   )}
//                 </div>
//                 {cardExpiry && (
//                   <span className="text-[14px] text-black font-medium">
//                     Expires: {cardExpiry}
//                   </span>
//                 )}
//               </div>
//             </div>


//             <button
//               onClick={handleUpdatePaymentMethod}
//               className="text-[14px] font-medium text-[#845EC2] border bg-[#F8F3FF] px-4 py-2 rounded-lg hover:bg-[#f3e8ff] transition mr-12 relative group"
//               style={{ border: "0.5px solid var(--Secc, #8B55DD)" }}
//             >
//               Manage on Stripe
//             </button>
//           </div>
//         )}


//         {!isPaidYearlyPlan && (
//           <>
//             <div className="mt-2">
//               <h2 className="billing-usage-box-headings">Usage</h2>
//             </div>


//             {isTrialActive ? (
//               <div className="billing-usage-box mt-3" style={{ height: "120px" }}>
//                 <div className="billing-usage-grid">
//                   <div className="billing-usage-left mt-3">
//                     <div className="billing-usage-row">
//                       <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                         <span>Uploaded Documents</span>
//                         <span className="date-billing">
//                           {uploadedDocsCount} / {totalDocs}
//                         </span>
//                       </div>
//                       <div className="billing-usage-bar">
//                         <div className="billing-usage-fill" style={{ width: `${docsUsedPercentage}%` }}></div>
//                       </div>
//                     </div>


//                     <div className="billing-usage-row">
//                       <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
//                         <span>Trial Ends In</span>
//                         <span className="date-billing" style={{ marginLeft: "auto" }}>
//                           {trialDaysLeft} / {totalTrialDays} days
//                         </span>
//                       </div>
//                       <div className="billing-usage-bar">
//                         <div className="billing-usage-fill" style={{ width: `${trialUsedPercentage}%` }}></div>
//                       </div>
//                     </div>
//                   </div>


//                   <div className="billing-usage-right">
//                     {/* <p className="billing-limit-warning">
//                       You're close to your limit. Upgrade to avoid interruptions
//                     </p> */}
//                   </div>
//                 </div>
//               </div>
//             ) : (
//               <div className="billing-usage-box mt-2" style={{ height: "100px" }}>
//                 <div className="billing-usage-grid-month">
//                   <div className="billing-usage-left">
//                     <div className="billing-usage-row">
//                       <span>Uploaded Documents</span>
//                       <div className="date-billing-month-wrapper">
//                         <span className="date-billing-month">
//                           {uploadedDocsCount} / {totalDocs}
//                         </span>
//                       </div>


//                       <div className="billing-usage-bar-month">
//                         <div className="billing-usage-fill" style={{ width: `${docsUsedPercentage}%` }}></div>
//                       </div>
//                     </div>
//                   </div>


//                   <div className="billing-usage-right">
//                     <p className="billing-limit-warning-month">
//                       You're close to your limit. Upgrade to avoid interruptions
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             )}
//           </>
//         )}
//       </div>


//       {isPopupOpen && (popupType === "payment" ? (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//           {/* Payment popup content */}
//           <div className="popup-content" style={{ width: "484px" }}>
//             <span className="close-btn" onClick={handleClosePopup}>&times;</span>
//             <h2 className="custom-popup-title-billing">Confirm Your Plan Upgrade</h2>
//             <p className="custom-popup-subtext-billing">
//               You're upgrading to the full version of your plan. Enjoy all premium features!
//             </p>
//             <div className="popup-button" onClick={handleUpgrade}>
//               <p className="popup-button-payment">
//                 {isProcessingPayment ? "Processing Your Payment ....." : "Confirm Upgrade"}
//               </p>
//             </div>
//           </div>
//         </div>
//       ) : (
//         <PlanComparisonPopup
//           onClose={handleClosePopup}
//           currencySymbol={currencySymbol}
//           onUpgradeClick={handleOpenPopup}
//           handleUpgrade={handleUpgrade}
//           planType={planType}
//           subscriptionType={subscriptionType}
//           isProcessingPayment={isProcessingPayment}
//         />
//       ))}


//       {showCancelPopup && (
//         <CancelSubscriptionPopup
//           onClose={() => setShowCancelPopup(false)}
//           onConfirm={handleCancelSubscription}
//           isLoading={isCancellingSubscription}
//         />
//       )}


//       {isActivating && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//           <img src="/leftside-celebration.svg" alt="celebration left" style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }} />
//           <img src="/right-side-celebration.svg" alt="celebration right" style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }} />
//           <div className="activation-popup">
//             <img src="/celebrate-icon.svg" alt="confetti" className="confetti-icon" />
//             <h2>Welcome on board!</h2>
//             <p>
//               ✨ We're setting up your premium features...
//               <br />
//               Hang tight, this will take just a moment!
//             </p>
//             <button disabled className="activating-btn">
//               <span className="typing-animation">Activating your account</span>
//             </button>
//           </div>
//         </div>
//       )}


//       {showGetStarted && (
//         <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
//           <img src="/leftside-celebration.svg" alt="celebration left" style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }} />
//           <img src="/right-side-celebration.svg" alt="celebration right" style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }} />
//           <div className="activation-popup">
//             <img src="/celebrate-icon.svg" alt="confetti" className="confetti-icon" />
//             <h2>You're all set!</h2>
//             <p>Ready to unlock the full potential of your documents?</p>
//             <button className="activating-btn" onClick={() => { setShowGetStarted(false); window.location.href = "/ai-Copilot"; }}>
//               Get Started Now
//             </button>
//           </div>
//         </div>
//       )}


//       {isPopupOpen && isTrialActive && (
//         <PlanComparisonPopups
//           onClose={handleClosePopup}
//           currencySymbol={currencySymbol}
//           onUpgradeClick={handleOpenPopup}
//         />
//       )}
//     </div>
//   );
// };


// export default Billing;

import React, { useState, useEffect, useRef } from "react";
import { Header } from "../../components/Header/Header";
import axios from "axios";
import { toast } from "../../utils/appToast";
import { currentWorkspacePermission } from "../../utils/workspace";
import { getFreshAccessToken } from "../chat/api";
import api from "../chat/api";
import {
  getCachedSubscriptionStatus,
  setCachedSubscriptionStatus,
} from "../../utils/subscriptionStatus";
import PlanComparisonPopup from "../chat/PlanComparisonPopup";
import CancelSubscriptionPopup from "../chat/CancelSubscriptionPopup";
import PlanComparisonPopups from "../chat/PlanComparisonPopups";
import { fetchRfpSubscription, PAID_STATES } from "../../services/rfpBillingApi";
import TrialEndedCard from "./billing/TrialEndedCard";
import ExtractorStudioBilling from "../Extractor/Studio/billing/BillingPage";
import ActiveCard from "./billing/ActiveCard";
import FailedPaymentCard from "./billing/FailedPaymentCard";
import ProcessingBanner from "./billing/ProcessingBanner";

// Each product's billing, one tab each: [tab key in ?tab=, label, subtitle].
const BILLING_TABS = [
  ["rfp", "RFP Manager", "Manage your plan, payment method and invoices."],
  ["extractor-studio", "Extractor Studio", "Manage your Extractor Studio subscription, credits and payment details."],
];
const tabFromUrl = () =>
  new URLSearchParams(window.location.search).get("tab") === "extractor-studio" ? "extractor-studio" : "rfp";

const Billing = () => {
  const [token, setToken] = useState(null);
  const [subscriptionType, setSubscriptionType] = useState("");
  const [isLoadingSubscription, setIsLoadingSubscription] = useState(true);
  const [uploadedDocsCount, setUploadedDocsCount] = useState(0);
  const [expiresOn, setExpiresOn] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("Grow");
  const [isTrialActive, setIsTrialActive] = useState(true);
  const [popupType, setPopupType] = useState("payment");
  const [isPaidYearlyPlan, setIsPaidYearlyPlan] = useState(false);
  const [isYearlyTrial, setIsYearlyTrial] = useState(false);
  const [planType, setPlanType] = useState("");
  const [quotaType, setQuotaType] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("$");
  const [countryCode, setCountryCode] = useState("");
  const [userIP, setUserIP] = useState("");
  const [cardLast4, setCardLast4] = useState("");
  const [cardExpiry, setCardExpiry] = useState("");
  const [cardBrand, setCardBrand] = useState("");
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [isCancellingSubscription, setIsCancellingSubscription] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [isActivating, setIsActivating] = useState(false);
  const [showGetStarted, setShowGetStarted] = useState(false);
  const pollingActiveRef = useRef(true);
  const previousSubscriptionType = useRef("");
  const previousPlanType = useRef("");

  // RFP Manager's own subscription state — separate from the legacy
  // per-user system fetched below (which is disabled for now; see the
  // bottom of this component). `rfpAccessLoaded` just gates the spinner —
  // once true, the new page always renders, whether or not the fetch
  // actually succeeded, since it's the only page this route shows today.
  const [rfpAccess, setRfpAccess] = useState(null);
  // Only the workspace owner manages billing; invited admins see it like any other member.
  const canManageBilling = Boolean(rfpAccess) && currentWorkspacePermission() === "owner";
  const [rfpAccessLoaded, setRfpAccessLoaded] = useState(false);

  // Returning from a successful Checkout stays in this "processing" window
  // until the subscription genuinely confirms active — ProcessingBanner
  // owns that polling loop itself; this flag just decides which of the
  // three new-system views to show.
  const [justPaid, setJustPaid] = useState(
    () => tabFromUrl() === "rfp" && new URLSearchParams(window.location.search).get("billing") === "success"
  );
  const [tab, setTab] = useState(tabFromUrl);
  const switchTab = (next) => {
    setTab(next);
    const params = new URLSearchParams(window.location.search);
    if (next === "rfp") params.delete("tab");
    else params.set("tab", next);
    const qs = params.toString();
    window.history.replaceState({}, "", `${window.location.pathname}${qs ? `?${qs}` : ""}`);
  };
  // Set when the payment was for added seats on an already-active plan: that's confirmed
  // by the seat count reaching this number, not by the plan state (it was active already).
  const [targetSeats] = useState(() => Number(new URLSearchParams(window.location.search).get("target_seats")) || null);

  useEffect(() => {
    fetchPlans();
    fetchSubscriptionStatus();
    fetchRfpSubscription()
      .then((data) => setRfpAccess(data))
      .catch((err) => {
        console.error("Failed to fetch RFP subscription status:", err);
      })
      .finally(() => setRfpAccessLoaded(true));
    // Stop any in-flight cancellation polling when the page unmounts.
    return () => {
      pollingActiveRef.current = false;
    };
  }, []);

  const refreshRfpAccess = () => {
    fetchRfpSubscription()
      .then((data) => setRfpAccess(data))
      .catch((err) => console.error("Failed to refresh RFP subscription status:", err));
  };

  const fetchPlans = async () => {
    let token = await getFreshAccessToken();
    try {
      const response = await api.get("api/v1/accounts/get-plans/");
      if (response.status === 200) {
        const { ip_address, currency, country_code } = response.data;
        setUserIP(ip_address);
        setCountryCode(country_code);
        if (currency === "INR") {
          setCurrencySymbol("₹");
        } else {
          setCurrencySymbol("$");
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
    }
  };

  const fetchSubscriptionStatus = async () => {
    let token = await getFreshAccessToken();
    try {
      const cached = getCachedSubscriptionStatus();
      let response;
      if (cached) {
        response = { data: cached, status: 200 };
      } else {
        response = await api.get(
          "api/v1/accounts/get-subscription-status/",
          {
            validateStatus: (status) => true,
          }
        );
        if (response.status === 200) setCachedSubscriptionStatus(response.data);
      }

      if (response.status === 200) {
        const {
          subscription_type,
          plan_type,
          uploaded_docs_count,
          expires_on,
          card_last4,
          card_expiry,
          card_brand,
          quota,
        } = response.data;
        setSubscriptionType(subscription_type);
        setPlanType(plan_type);
        setUploadedDocsCount(uploaded_docs_count || 0);
        setExpiresOn(expires_on);
        setCardLast4(card_last4);
        setCardExpiry(card_expiry);
        setCardBrand(card_brand);
        setQuotaType(quota);
        previousSubscriptionType.current = subscription_type;
        previousPlanType.current = plan_type;
        
        const isTrial = !(
          subscription_type === "paid_subs" ||
          subscription_type === "pending_cancellation" ||
          subscription_type === "plan_upgrade_pending_payment"
        );
        setIsTrialActive(isTrial);
        setIsPaidYearlyPlan(
          (subscription_type === "paid_subs" ||
            subscription_type === "pending_cancellation") &&
            plan_type === "yearly"
        );
        const isActualTrial = subscription_type === "trial" && plan_type === "trial";
        setIsYearlyTrial(isActualTrial && quota === "yearly");
      }
    } catch (error) {
      console.error("Failed to fetch subscription status:", error);
    } finally {
      setIsLoadingSubscription(false);
    }
  };

  const handleOpenPopup = (planTitle, type = "payment", selectedPlanType = "monthly") => {
    setSelectedPlan(planTitle);
    setPopupType(type);
    setIsProcessingPayment(false);
    setPlanType(selectedPlanType);

    const isTrial = subscriptionType === "trial" && planType === "trial";
    const isTrialUser = isTrial || isTrialActive;

    if (isTrialUser) {
      setIsPopupOpen(true);
      return;
    }

    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    pollingActiveRef.current = false;
    setIsPopupOpen(false);
    setIsProcessingPayment(false);
  };

  const handleUpgrade = async () => {
    pollingActiveRef.current = true;
    setIsProcessingPayment(true);
    // Add your upgrade logic here
  };

  const handleUpdatePaymentMethod = async () => {
    try {
      const response = await api.post(`api/v1/accounts/create-portal-session/`);
      if (response.status === 200 && response.data?.url) {
        window.location.href = response.data.url;
      } else {
        toast.error("Failed to retrieve payment portal link.");
      }
    } catch (error) {
      console.error("Error creating portal session:", error);
      toast.error("Something went wrong while opening the payment portal.");
    }
  };

  const handleCancelSubscription = async () => {
    // Guard against double clicks while a request is already in flight.
    if (isCancellingSubscription) return;

    setIsCancellingSubscription(true);
    pollingActiveRef.current = true;

    try {
      await getFreshAccessToken();

      const response = await api.post(
        "api/v1/accounts/cancel-subscription/",
        {},
        { validateStatus: (status) => true }
      );

      // Backend returns 202 (Accepted) once the cancellation task is queued.
      if (response.status === 200 || response.status === 202) {
        // The actual cancellation runs async on the backend (Celery), flipping
        // the subscription to "pending_cancellation". Poll until it lands.
        const maxAttempts = 8; // ~40s total (8 x 5s)
        let attempt = 0;

        const pollUntilPendingCancellation = async () => {
          if (!pollingActiveRef.current) return;

          try {
            const result = await api.get(
              "api/v1/accounts/get-subscription-status/",
              { validateStatus: (status) => true }
            );

            const isPending =
              (result.status === 200 ||
                result.status === 404 ||
                result.status === 202) &&
              result.data?.subscription_type === "pending_cancellation";

            if (isPending) {
              // Refresh cached status and derived UI state from the fresh data.
              if (result.status === 200) {
                setCachedSubscriptionStatus(result.data);
              }
              toast.success("Your subscription has been cancelled.");
              setShowCancelPopup(false);
              setIsCancellingSubscription(false);
              fetchSubscriptionStatus();
              return;
            }

            attempt++;
            if (attempt < maxAttempts) {
              setTimeout(pollUntilPendingCancellation, 5000);
            } else {
              toast.info(
                "Cancellation is processing. It may take a moment to reflect — please refresh later."
              );
              setShowCancelPopup(false);
              setIsCancellingSubscription(false);
            }
          } catch (err) {
            console.error("Error polling subscription status:", err);
            attempt++;
            if (attempt < maxAttempts) {
              setTimeout(pollUntilPendingCancellation, 5000);
            } else {
              toast.error(
                "Couldn't confirm the cancellation. Please refresh to check its status."
              );
              setShowCancelPopup(false);
              setIsCancellingSubscription(false);
            }
          }
        };

        pollUntilPendingCancellation();
      } else if (response.status === 404) {
        toast.error("No active subscription was found to cancel.");
        setIsCancellingSubscription(false);
      } else {
        toast.error("Failed to cancel the subscription. Please try again.");
        setIsCancellingSubscription(false);
      }
    } catch (error) {
      console.error("Error cancelling subscription:", error);
      toast.error("Something went wrong while cancelling the subscription.");
      setIsCancellingSubscription(false);
    }
  };

  const trialDocsLimit = 5;
  const paidDocsLimit = 70;
  const totalDocs = isTrialActive ? trialDocsLimit : paidDocsLimit;
  const docsUsedPercentage = Math.max(0, Math.min((uploadedDocsCount / totalDocs) * 100, 100));

  const totalTrialDays = 14;
  const getDaysLeft = () => {
    if (!expiresOn) return 0;
    const today = new Date();
    const expiry = new Date(expiresOn);
    today.setHours(0, 0, 0, 0);
    expiry.setHours(0, 0, 0, 0);
    const diffTime = expiry.getTime() - today.getTime();
    const dayDiff = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    return Math.max(dayDiff, 0);
  };

  const trialDaysLeft = getDaysLeft();
  const trialUsedPercentage = Math.max(0, Math.min(((totalTrialDays - trialDaysLeft) / totalTrialDays) * 100, 100));

  const formatDate = (isoDate) => {
    if (!isoDate) return "";
    const date = new Date(isoDate);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const formattedExpiryDate = formatDate(expiresOn);

  // The legacy per-user billing page below is disabled for now — the new
  // RFP Manager billing page is the only thing this route shows, so there's
  // no flash of the old UI before switching over. This check runs first,
  // ahead of `isLoadingSubscription`, specifically so the old spinner never
  // shows either. Only the Active/Processing states from the handoff
  // aren't built yet; re-enabling the legacy page is just restoring the
  // `rfpAccess.can_use === false` condition this replaced.
  const showProcessing =
    justPaid && (targetSeats ? (rfpAccess?.seat_quantity ?? 0) < targetSeats : !PAID_STATES.has(rfpAccess?.state));

  const rfpBilling = !rfpAccessLoaded ? (
    <div className="flex items-center justify-center py-24">
      <div className="w-9 h-9 border-4 border-[#f3f3f3] border-t-[#c95ebe] rounded-full animate-[spin_1s_linear_infinite]"></div>
    </div>
  ) : showProcessing ? (
    <div className="flex flex-col gap-[22px]">
      <ProcessingBanner
        targetSeats={targetSeats}
        onConfirmed={(data) => {
          setRfpAccess(data);
          setJustPaid(false);
        }}
      />
    </div>
  ) : rfpAccess?.state === "past_due" ? (
    <FailedPaymentCard subscription={rfpAccess} canManageBilling={canManageBilling} onRefresh={refreshRfpAccess} />
  ) : rfpAccess?.can_use && rfpAccess?.state !== "trialing" ? (
    <ActiveCard subscription={rfpAccess} canManageBilling={canManageBilling} onRefresh={refreshRfpAccess} />
  ) : (
    <TrialEndedCard
      canManageBilling={canManageBilling}
      state={rfpAccess?.state}
      trialEndsAt={rfpAccess?.trial_ends_at}
      periodEnd={rfpAccess?.current_period_end}
    />
  );

  return (
    <div className="pt-2.5 font-[Outfit,sans-serif] w-full max-w-[1200px]">
      <div className="mx-auto w-full max-w-[1000px] px-4 py-4 sm:px-8">
        <div className="mb-5 flex flex-wrap items-start justify-between gap-3">
          <div>
            <h1 className="text-[24px] font-semibold tracking-[-0.02em] text-[#1A1A1A]">Billing</h1>
            <p className="mt-1 text-[13px] text-[#52525B]">{BILLING_TABS.find(([key]) => key === tab)[2]}</p>
          </div>
          <div role="tablist" className="inline-flex rounded-[10px] border border-[#ECE9EE] bg-[#FAF9FB] p-1">
            {BILLING_TABS.map(([key, label]) => (
              <button
                key={key}
                type="button"
                role="tab"
                aria-selected={tab === key}
                onClick={() => switchTab(key)}
                className={`rounded-[8px] px-3.5 py-1.5 text-[13.5px] font-medium transition-colors ${
                  tab === key
                    ? "border border-[#ECE9EE] bg-white text-[#A04A97] shadow-[0_1px_2px_rgba(16,24,40,0.06)]"
                    : "border border-transparent text-[#52525B] hover:text-[#1A1A1A]"
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
        {tab === "extractor-studio" ? <ExtractorStudioBilling /> : rfpBilling}
      </div>
    </div>
  );

  // --- Disabled for now (unreachable — the return above always fires first) ---
  // Everything below is the legacy per-user Billing page. Left in place,
  // not deleted, so re-enabling it later is just removing the early
  // return above rather than rebuilding this from scratch.
  // eslint-disable-next-line no-unreachable
  return (
    <div className="w-full">
      <style>{`
        @keyframes typingWords {
          0% { content: "✨"; }
          33% { content: "🛠️"; }
          66% { content: "⏳"; }
          100% { content: "✨"; }
        }
        .typing-animation::after {
          content: "✨ Activating";
          animation: typingWords 2.5s steps(1) infinite;
        }
      `}</style>
      <div className="pt-2.5 font-[Outfit,sans-serif] w-full max-w-[1200px]">
        <div>
          <div className="mt-1">
            <h2 className="text-[#18101c] font-[Outfit] text-base font-semibold mt-5">Billing Information</h2>
          </div>
          <div className="relative mt-1 w-full overflow-hidden rounded-xl flex items-stretch min-h-[148px] bg-[linear-gradient(93deg,#6f52ed_0.61%,#9c79d7_74.54%)] shadow-[0_54px_15px_0_rgba(0,0,0,0),0_34px_14px_0_rgba(0,0,0,0.01),0_19px_12px_0_rgba(0,0,0,0.05),0_9px_9px_0_rgba(0,0,0,0.09),0_2px_5px_0_rgba(0,0,0,0.1)]">
            <div className="relative z-10 flex flex-col justify-between gap-3 p-5 sm:p-6 flex-1 max-w-[640px]">
              <div>
                {isPaidYearlyPlan ? (
                  <div className="flex items-center gap-2">
                    <span className="text-white text-base font-semibold">
                      Need More Power?⚡️
                    </span>
                  </div>
                ) : (
                  <h3 className="text-white font-[Outfit] text-base font-semibold">
                    Ready for Even More? 🚀
                  </h3>
                )}

                <p className="text-white font-[Outfit] text-[14px] font-medium mt-[5px]">
                  {isPaidYearlyPlan ? (
                    <>
                      Unlock Unlimited Uploads, Custom Knowledgebases &
                      Enterprise-Grade Security — with the{" "}
                      <strong>Enterprise Plan</strong>.
                    </>
                  ) : (
                    <>
                      Upgrade to the Grow Plan for Unlimited Access and
                      Advanced Features!
                    </>
                  )}
                </p>
              </div>

              {isPaidYearlyPlan ? (
                <button
                  className="inline-flex w-fit px-[22px] py-2 justify-center items-center rounded-[9px] bg-[#f1e9ff] cursor-pointer text-[#8b55dd] text-center font-[Outfit] text-base font-semibold hover:bg-[#e7daff] transition-colors"
                  onClick={() => window.open("https://app.lemcal.com/@shobhitg", "_blank")}
                >
                  <span className="flex items-center gap-2">
                    Talk to Sales
                    <img src="/coming-soon-icon.svg" alt="Talk to Sales" className="w-5 h-5" />
                  </span>
                </button>
              ) : (
                <button
                  className="inline-flex w-fit px-[22px] py-2 justify-center items-center rounded-[9px] bg-[#f5f4f3] cursor-pointer text-[#8b55dd] text-center font-[Outfit] text-base font-semibold hover:bg-[#ece9e6] transition-colors"
                  onClick={() => handleOpenPopup("Grow", isTrialActive ? "payment" : "info")}
                >
                  {isTrialActive ? "Upgrade Now" : "Upgrade"}{" "}
                  <span className="ml-1.5">
                    <img src="/account-image-upload.svg" alt="arrow" />
                  </span>
                </button>
              )}
            </div>

            {isTrialActive ? (
              <div className="hidden sm:block relative shrink-0 w-[220px] md:w-[300px]">
                <img src="/Illustration-1.svg" alt="Upgrade illustration" className="w-[305px] max-w-none absolute right-2 bottom-0" />
              </div>
            ) : (
              <div className="hidden sm:block relative shrink-0 w-[190px] md:w-[220px]">
                <img src="/Illustration-2.svg" alt="Post-trial illustration" className="w-[205px] max-w-none absolute right-2 -bottom-[29px]" />
              </div>
            )}
          </div>
        </div>

        <div className="mt-3">
          <h2 className="text-[#18101c] font-[Outfit] text-base font-semibold mt-5">Selected Plan</h2>
        </div>
        <div className="w-full mt-2 pb-4 self-stretch rounded-md border border-[rgba(0,0,0,0.1)] bg-[#fef9f7] relative">
          <div className="flex justify-between items-center">
            <h4 className="text-[#8b55dd] font-[Outfit] text-[15px] font-semibold ml-6">
              {isYearlyTrial
                ? "Trial Plan"
                : isPaidYearlyPlan
                ? "Grow Plan"
                : isTrialActive
                ? "Trial Plan"
                : "Starter Plan"}
            </h4>

            <div className="inline-flex px-3 py-1.5 justify-center items-center gap-1 rounded-[20px] border border-[rgba(139,85,221,0.16)] text-[13.6px] text-[#6a36d9] mr-3 mt-1.25">
              <img src="/billing-hourglass.svg" alt="hourglass icon" className="" />
              {trialDaysLeft} days left
            </div>
          </div>

          <div className="">
            <div className="text-[#18101c] font-[Outfit] text-xl font-semibold ml-6">
              {isYearlyTrial
                ? currencySymbol === "₹" ? "Free For 14 days" : "Free For 14 days"
                : isPaidYearlyPlan
                ? currencySymbol === "₹" ? "₹17,032.00" : "$299.00"
                : isTrialActive
                ? currencySymbol === "₹" ? "₹Free For 14 days" : "Free For 14 days"
                : currencySymbol === "₹" ? "₹3,338.00" : "$39.00"}
              <span className="text-[#52525b] font-[Outfit] text-[14px] font-normal ml-1">
                {isYearlyTrial ? "" : isPaidYearlyPlan ? "/year" : isTrialActive ? "" : "/month"}
              </span>
            </div>

            <div className="flex flex-col md:flex-row md:justify-between gap-2 md:gap-8 mt-2">
              <ul className="list-disc list-inside p-0 m-0 flex-1 pl-[1.8rem] text-[15.2px] text-[#444] space-y-2">
                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-sm font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>
                    Upload Limit:{" "}
                    <strong>
                      <span className="text-[#a04a97] font-[Outfit] text-sm font-medium">
                        {isPaidYearlyPlan ? "Unlimited Document Uploads" : isTrialActive ? "5 documents" : "70 documents"}
                      </span>
                    </strong>
                  </span>
                </li>

                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-[14px] font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>With AI Copilot and AI search on knowledgebase</span>
                </li>

                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-[14px] font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>
                    {isPaidYearlyPlan ? (
                      <>Billed Yearly</>
                    ) : isTrialActive ? (
                      <>
                        Trial Duration:{" "}
                        <strong>
                          <span className="text-[#a04a97] font-[Outfit] text-[14px] font-medium">14 days</span>
                        </strong>
                      </>
                    ) : (
                      <>
                        Billed Monthly{" "}
                        <span className="text-[#8b55dd] font-[Outfit] text-[13px] font-normal">
                          (Next billing on <strong>{formattedExpiryDate}</strong>)
                        </span>
                      </>
                    )}
                  </span>
                </li>
              </ul>

              <ul className="list-disc list-inside p-0 m-0 flex-1 pl-[1.8rem] text-[15.2px] text-[#444] space-y-3">
                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-[14px] font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>
                    AI Queries:{" "}
                    <strong>
                      <span className="text-[#a04a97] font-[Outfit] text-[14px] font-medium">Unlimited</span>
                    </strong>
                  </span>
                </li>

                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-[14px] font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>
                    Maximum File Size:{" "}
                    <strong>
                      <span className="text-[#a04a97] font-[Outfit] text-[14px] font-medium">
                        {isPaidYearlyPlan || isYearlyTrial ? "25MB per document" : "25MB per document"}
                      </span>
                    </strong>
                  </span>
                </li>

                <li className="flex items-start gap-2 text-[#73607b] font-[Outfit] text-[14px] font-medium">
                  <span className="mt-1 w-2 h-2 rounded-full bg-black flex-shrink-0" style={{ minWidth: "8px" }}></span>
                  <span>
                    {isPaidYearlyPlan || !isTrialActive ? "Advanced Data Extraction" : "With Advanced Data Extraction"}
                  </span>
                </li>
              </ul>
            </div>

            <div className="flex justify-between items-center mb-1.5">
              {!isPaidYearlyPlan && (
                <div href="#" className="text-[#3f3f46] font-[Outfit] text-[14px] font-semibold ml-7">
                  Need more?{" "}
                  <strong
                    className="text-[#8b55dd] font-[Outfit] text-[14px] font-semibold underline cursor-pointer"
                    onClick={() => {
                      setTimeout(() => {
                        if (planType === "monthly" && (subscriptionType === "paid_subs" || subscriptionType === "plan_upgrade_pending_payment")) {
                          setIsPopupOpen(true);
                          setPopupType("info");
                        } else {
                          handleOpenPopup("Grow", isTrialActive ? "payment" : "info");
                        }
                      }, 100);
                    }}
                  >
                    Upgrade your plan
                  </strong>
                </div>
              )}

              {subscriptionType === "pending_cancellation" && planType === "yearly" ? (
                <p className="text-gray-600 text-[14px] font-medium" style={{ marginLeft: "515px" }}>
                  You'll still have access to premium features until <strong>{formattedExpiryDate}</strong>.
                </p>
              ) : subscriptionType === "pending_cancellation" && planType === "monthly" ? (
                <p className="text-gray-600 text-[14px] font-medium" style={{ marginRight: "75px" }}>
                  You'll still have access to premium features until <strong>{formattedExpiryDate}</strong>.
                </p>
              ) : (
                <div>
                  {subscriptionType === "paid_subs" && (planType === "monthly" || planType === "yearly") && (isPaidYearlyPlan ? (
                    <button className="text-[rgba(226,25,25,0.75)] font-[Outfit] text-[14px] font-semibold underline cursor-pointer mr-5 absolute top-[9.8rem] right-4" onClick={() => setShowCancelPopup(true)}>
                      Cancel Subscription
                    </button>
                  ) : (
                    <button className="text-[rgba(226,25,25,0.75)] font-[Outfit] text-[14px] font-semibold underline cursor-pointer mr-5 mt-4" onClick={() => setShowCancelPopup(true)}>
                      Cancel Subscription
                    </button>
                  ))}
                </div>
              )}
            </div>

            {isPaidYearlyPlan && !(subscriptionType === "pending_cancellation" && planType === "yearly") && (
              <p className="ml-8 text-[#52525b] font-[Outfit] text-[13px] font-medium" style={{ marginTop: "-1px" }}>
                Next billing on <strong>{formattedExpiryDate}</strong>
              </p>
            )}
          </div>
        </div>

        {(subscriptionType === "paid_subs" || subscriptionType === "plan_upgrade_pending_payment" || subscriptionType === "pending_cancellation") &&
          (planType === "monthly" || planType === "yearly") && (
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mt-4">
            <div>
              <h2 className="text-[#18101c] font-[Outfit] text-base font-semibold">
                Payment & Invoices
              </h2>
              <p className="text-[14px] text-gray-500 mt-1">
                Manage your card and view your invoice history
              </p>

              <div className="flex items-center mt-3 gap-4">
                <div className="flex items-center gap-2">
                  <img src="/card-icon.svg" alt="Card Icon" className="w-5 h-5 text-[#845EC2]" />
                  {cardBrand && cardLast4 && (
                    <span className="text-[14px] text-black font-medium">
                      {cardBrand} ******{cardLast4}
                    </span>
                  )}
                </div>
                {cardExpiry && (
                  <span className="text-[14px] text-black font-medium">
                    Expires: {cardExpiry}
                  </span>
                )}
              </div>
            </div>

            <button
              onClick={handleUpdatePaymentMethod}
              className="text-[14px] font-medium text-[#845EC2] border bg-[#F8F3FF] px-4 py-2 rounded-lg hover:bg-[#f3e8ff] transition w-full sm:w-auto shrink-0 relative group"
              style={{ border: "0.5px solid var(--Secc, #8B55DD)" }}
            >
              Manage on Stripe
            </button>
          </div>
        )}

        {!isPaidYearlyPlan && (
          <>
            <div className="mt-2">
              <h2 className="text-[#18101c] font-[Outfit] text-base font-semibold">Usage</h2>
            </div>

            {isTrialActive ? (
              <div className="w-full rounded-md border border-[rgba(0,0,0,0.1)] bg-white px-4 py-3 text-[15.2px] mt-3">
                <div className="flex justify-between gap-8 flex-wrap">
                  <div className="flex-1 min-w-[250px] mt-3">
                    <div className="mb-4">
                      <div className="flex items-center gap-[5px]">
                        <span className="text-[#52525b] font-[Outfit] text-[13px] font-medium">Uploaded Documents</span>
                        <span className="text-[#52525b] font-[Outfit] text-[13px] font-medium ml-auto">
                          {uploadedDocsCount} / {totalDocs}
                        </span>
                      </div>
                      <div className="w-full h-2 bg-[#e0e0e0] rounded-[4px] overflow-hidden mt-2">
                        <div className="bg-[linear-gradient(90deg,#f3904f_30.06%,#8b55dd_100%)] h-full rounded-l-[4px]" style={{ width: `${docsUsedPercentage}%` }}></div>
                      </div>
                    </div>

                    <div className="mb-4">
                      <div className="flex items-center gap-[5px]">
                        <span className="text-[#52525b] font-[Outfit] text-[13px] font-medium">Trial Ends In</span>
                        <span className="text-[#52525b] font-[Outfit] text-[13px] font-medium ml-auto">
                          {trialDaysLeft} / {totalTrialDays} days
                        </span>
                      </div>
                      <div className="w-full h-2 bg-[#e0e0e0] rounded-[4px] overflow-hidden mt-2">
                        <div className="bg-[linear-gradient(90deg,#f3904f_30.06%,#8b55dd_100%)] h-full rounded-l-[4px]" style={{ width: `${trialUsedPercentage}%` }}></div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-end">
                    {/* <p className="text-[#e95150] font-[Outfit] text-[13px] font-medium mt-[50px] ml-[60px]">
                      You're close to your limit. Upgrade to avoid interruptions
                    </p> */}
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-full rounded-md border border-[rgba(0,0,0,0.1)] bg-white px-4 py-3 text-[15.2px] mt-2">
                <div className="">
                  <div className="flex-1 min-w-[250px] mt-3">
                    <div className="mb-4">
                      <span className="text-[#52525b] font-[Outfit] text-[13px] font-medium">Uploaded Documents</span>
                      <div className="flex justify-end w-full">
                        <span className="text-right mr-2.5 text-[#52525b] font-[Outfit] text-[13px] font-medium">
                          {uploadedDocsCount} / {totalDocs}
                        </span>
                      </div>

                      <div className="bg-[#e0e0e0] w-full h-[11px] rounded-[4px] overflow-hidden mt-2">
                        <div className="bg-[linear-gradient(90deg,#f3904f_30.06%,#8b55dd_100%)] h-full rounded-l-[4px]" style={{ width: `${docsUsedPercentage}%` }}></div>
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col items-end">
                    <p className="text-[#e95150] font-[Outfit] text-[13px] font-medium mr-2.5">
                      You're close to your limit. Upgrade to avoid interruptions
                    </p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {isPopupOpen && (popupType === "payment" ? (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <div className="bg-white p-6 rounded-xl relative" style={{ width: "484px" }}>
            <span className="absolute top-4 right-4 text-2xl text-gray-500 hover:text-gray-700 cursor-pointer" onClick={handleClosePopup}>&times;</span>
            <h2 className="text-[#18101c] font-[Outfit] text-[20px] font-semibold self-stretch -ml-[184px]">Confirm Your Plan Upgrade</h2>
            <p className="text-[#52525b] font-[Outfit] text-[13px] font-medium text-left">
              You're upgrading to the full version of your plan. Enjoy all premium features!
            </p>
            <div className="cursor-pointer bg-[#c95ebe] text-white p-2 rounded mt-4 text-center" onClick={handleUpgrade}>
              <p className="">
                {isProcessingPayment ? "Processing Your Payment ....." : "Confirm Upgrade"}
              </p>
            </div>
          </div>
        </div>
      ) : (
        <PlanComparisonPopup
          onClose={handleClosePopup}
          currencySymbol={currencySymbol}
          onUpgradeClick={handleOpenPopup}
          handleUpgrade={handleUpgrade}
          planType={planType}
          subscriptionType={subscriptionType}
          isProcessingPayment={isProcessingPayment}
        />
      ))}

      {showCancelPopup && (
        <CancelSubscriptionPopup
          onClose={() => setShowCancelPopup(false)}
          onConfirm={handleCancelSubscription}
          isLoading={isCancellingSubscription}
        />
      )}

      {isActivating && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <img src="/leftside-celebration.svg" alt="celebration left" style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }} />
          <img src="/right-side-celebration.svg" alt="celebration right" style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }} />
          <div className="relative z-20 flex flex-col items-center bg-white p-8 rounded-xl text-center">
            <img src="/celebrate-icon.svg" alt="confetti" className="w-[74.5px] h-[86px] shrink-0 ml-[230px] -mt-2.5" />
            <h2 className="text-xl font-bold mt-2">Welcome on board!</h2>
            <p className="text-gray-600 mt-2">
              ✨ We're setting up your premium features...
              <br />
              Hang tight, this will take just a moment!
            </p>
            <button disabled className="bg-[#c95ebe] text-white px-6 py-2 rounded-lg mt-4 opacity-80 cursor-not-allowed">
              <span className="inline-block font-semibold text-[16px] ml-[2px] text-white typing-animation">Activating your account</span>
            </button>
          </div>
        </div>
      )}

      {showGetStarted && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <img src="/leftside-celebration.svg" alt="celebration left" style={{ position: "absolute", top: "50%", left: "32rem", transform: "translateY(-50%)", zIndex: 1 }} />
          <img src="/right-side-celebration.svg" alt="celebration right" style={{ position: "absolute", top: "50%", left: "49rem", transform: "translateY(-50%)", zIndex: 1 }} />
          <div className="relative z-20 flex flex-col items-center bg-white p-8 rounded-xl text-center">
            <img src="/celebrate-icon.svg" alt="confetti" className="w-[74.5px] h-[86px] shrink-0 ml-[230px] -mt-2.5" />
            <h2 className="text-xl font-bold mt-2">You're all set!</h2>
            <p className="text-gray-600 mt-2">Ready to unlock the full potential of your documents?</p>
            <button className="bg-[#c95ebe] text-white px-6 py-2 rounded-lg mt-4 cursor-pointer hover:bg-[#b04ca5] transition" onClick={() => { setShowGetStarted(false); window.location.href = "/ai-Copilot"; }}>
              Get Started Now
            </button>
          </div>
        </div>
      )}

      {isPopupOpen && isTrialActive && (
        <PlanComparisonPopups
          onClose={handleClosePopup}
          currencySymbol={currencySymbol}
          onUpgradeClick={handleOpenPopup}
        />
      )}
    </div>
  );
};

export default Billing;